var scrollToAnchorOffSet = 120;

function scrollToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}

function scrollToAnchorOffset(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}
function scrollToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}

function isEmptyOrSpaces(str) {
    if (str === undefined) { return true; }
    return str === null || str.match(/^ *$/) !== null;
}

function nodeListToIds(list) {
    //console.log(' node list : %o', list);
    let nodeIds = [];
    if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {

            var itm = list[i];
            //console.log('%o - %o', itm, itm.checked);
            if (itm.checked) {
                nodeIds.push(itm.value);
            }
        }
    }
    //console.log('node ids : %o', nodeIds);
    return nodeIds;
}

function setMinHeight() {
    document.querySelectorAll('.feature-panel__img').forEach(function (img) {
        var fetPanel = img.closest('.feature-panel__container');
        if (fetPanel && fetPanel.style) {
            fetPanel.style.minHeight = img.offsetHeight + 'px';
        }
        
    });
}

window.addEventListener('load', setMinHeight);
window.addEventListener('resize', setMinHeight);
